import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// OPD API
export const opdApi = {
  getAll: () => axios.get(`${API}/opd`),
  getById: (id) => axios.get(`${API}/opd/${id}`),
  create: (data) => axios.post(`${API}/opd`, data),
  update: (id, data) => axios.put(`${API}/opd/${id}`, data),
  delete: (id) => axios.delete(`${API}/opd/${id}`),
  importExcel: (file, kategori) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('kategori', kategori);
    return axios.post(`${API}/opd/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// Partisipasi API
export const partisipasiApi = {
  getAll: () => axios.get(`${API}/partisipasi`),
  getAdminList: () => axios.get(`${API}/partisipasi/admin-list`),
  getMapPoints: () => axios.get(`${API}/partisipasi/map-points`),
  getRecent: (limit = 5) => axios.get(`${API}/partisipasi/recent?limit=${limit}`),
  getById: (id) => axios.get(`${API}/partisipasi/${id}`),
  create: (data) => axios.post(`${API}/partisipasi`, data),
  update: (id, data) => {
    const token = localStorage.getItem('token');
    return axios.put(`${API}/partisipasi/${id}`, data, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
  },
  delete: (id) => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API}/partisipasi/${id}`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
  },
};

// Settings API
export const settingsApi = {
  get: () => axios.get(`${API}/settings`),
  getPublic: () => axios.get(`${API}/settings/public`),
  update: (data) => axios.put(`${API}/settings`, data),
  uploadLogo: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/settings/upload-logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// Gallery API
export const galleryApi = {
  getAll: () => axios.get(`${API}/gallery`),
  create: (data) => axios.post(`${API}/gallery`, data),
  delete: (id) => axios.delete(`${API}/gallery/${id}`),
};

// Edukasi API
export const edukasiApi = {
  getAll: () => axios.get(`${API}/edukasi`),
  create: (data) => axios.post(`${API}/edukasi`, data),
  update: (id, data) => axios.put(`${API}/edukasi/${id}`, data),
  delete: (id) => axios.delete(`${API}/edukasi/${id}`),
};

// Agenda API
export const agendaApi = {
  getAll: () => axios.get(`${API}/agenda`),
  getUpcoming: () => axios.get(`${API}/agenda/upcoming`),
  create: (data) => axios.post(`${API}/agenda`, data),
  update: (id, data) => axios.put(`${API}/agenda/${id}`, data),
  delete: (id) => axios.delete(`${API}/agenda/${id}`),
};

// Berita API
export const beritaApi = {
  getAll: () => axios.get(`${API}/berita`),
  getActive: () => axios.get(`${API}/berita/active`),
  getActiveLight: () => axios.get(`${API}/berita/active-light`),
  getById: (id) => axios.get(`${API}/berita/${id}`),
  create: (data) => axios.post(`${API}/berita`, data),
  update: (id, data) => axios.put(`${API}/berita/${id}`, data),
  delete: (id) => axios.delete(`${API}/berita/${id}`),
};

// Stats API
export const statsApi = {
  get: () => axios.get(`${API}/stats`),
  getHome: () => axios.get(`${API}/stats/home`),
  getProgress: () => axios.get(`${API}/progress`),
};

// Export API
export const exportApi = {
  excel: (kategori = 'all') => {
    const token = localStorage.getItem('token');
    return axios.get(`${API}/export/excel`, { 
        params: { kategori },
      responseType: 'blob',
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
  },
  pdf: (kategori = 'all') => {
    const token = localStorage.getItem('token');
    return axios.get(`${API}/export/pdf`, { 
        params: { kategori },
      responseType: 'blob',
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
  },
};

// Import API
export const importApi = {
  excel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/import/excel`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// Kontak WhatsApp API
export const kontakWhatsAppApi = {
  get: () => axios.get(`${API}/kontak-whatsapp`),
  save: (data) => {
    const token = localStorage.getItem('token');
    return axios.post(`${API}/kontak-whatsapp`, data, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
  },
};

// Deteksi Ganda (Duplicate Detection) API
export const deteksiGandaApi = {
  getDuplicates: (field = 'nama_lengkap', opdId = null) => {
    const token = localStorage.getItem('token');
    const params = new URLSearchParams({ field });
    if (opdId && opdId !== 'all') params.append('opd_id', opdId);
    return axios.get(`${API}/deteksi-ganda?${params.toString()}`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
  },
  deleteDuplicates: (ids) => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API}/deteksi-ganda/hapus`, {
      data: ids,
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
  },
  mergeDuplicates: (primaryId, secondaryIds) => {
    const token = localStorage.getItem('token');
    return axios.post(`${API}/deteksi-ganda/gabung`, 
      { primary_id: primaryId, secondary_ids: secondaryIds },
      { headers: token ? { 'Authorization': `Bearer ${token}` } : {} }
    );
  },
};
